const DATETIME_PATTERN = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/
const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/

function pad(value) {
  return String(value).padStart(2, '0')
}

function formatDate(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

export function formatDateTime(value) {
  if (value == null || value === '') return ''

  if (typeof value === 'string') {
    if (DATETIME_PATTERN.test(value)) return value
    if (DATE_ONLY_PATTERN.test(value)) return `${value} 00:00:00`
    const normalized = value.replace('T', ' ').replace(/\.\d{3}Z?$/, '').replace(/Z$/, '')
    if (DATETIME_PATTERN.test(normalized)) return normalized
  }

  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return String(value)

  return formatDate(date)
}
